export default __webpack_public_path__ + "static/media/NORLYSText-Regular.353924b5.woff";